import { render, staticRenderFns } from "./TemplateSlot.vue?vue&type=template&id=50a87f96&scoped=true&"
import script from "./TemplateSlot.vue?vue&type=script&lang=js&"
export * from "./TemplateSlot.vue?vue&type=script&lang=js&"
import style0 from "./TemplateSlot.vue?vue&type=style&index=0&id=50a87f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a87f96",
  null
  
)

export default component.exports